import React from "react"
import styled from "styled-components"
import HomeFeatureSetList from "./HomeFeatureSetList"
import { SMALLCHAT_SHADOW } from "./consts/colors"

const HomeFeatureSetWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 80%;
  max-width: 1200px;
  padding: 20px 40px 40px 40px;
  background-color: white;
  box-shadow: 0px 20px 30px ${SMALLCHAT_SHADOW};
  border-radius: 12px;
  margin-bottom: 100px;

  @media (max-width: 768px) {
    margin-bottom: 50px;
    width: 90%;
    padding: 20px;
  }

  @media (max-width: 480px) {
    text-align: center;
    width: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px 10px 30px 10px;
    margin-bottom: 10px;
  }
`
const HomeFeatureSetTitle = styled.h3`
  margin-bottom: 30px;
  margin-top: 15px;

  @media (max-width: 768px) {
    margin-bottom: 10px;
    margin-top: 5px;
  }
`

const HomeFeatureSet = props => (
  <HomeFeatureSetWrapper>
    <HomeFeatureSetTitle>{props.title}</HomeFeatureSetTitle>
    <HomeFeatureSetList features={props.features} />
  </HomeFeatureSetWrapper>
)

export default HomeFeatureSet



// WEBPACK FOOTER //
// ./src/components/HomeFeatureSet.js